import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloseIcon from "@mui/icons-material/Close";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
import BlueLightOutlinedButton from "../../../../components/customButtons/BlueLightOutlineButton";
import BlueLightOutLinedMediumButton from "../../../../components/customButtons/BlueLightOutLinedMediumButton";
import { IoDocumentTextOutline } from "react-icons/io5";
import { uploadAssignment } from "../services/assignments";
import { set } from "date-fns";
import SubmitLoader from "../../../../../SAPPages/components/Loader/SubmitLoader";
import ErrorPopupScreen from "../../../../components/customPopup/ErrorPopupScreen";
import SussceeffulyMessageScreen from "../../../../components/customPopup/SussceeffulyMessageScreen";
export default function UploadNewAssignment({
  handleClose,
  selectedData,

 


  setFilteredData,
}) {

  const userId = localStorage.getItem("userId");

  const fileInputRef = useRef(null);
  const audioInputRef = useRef(null);
  const [file, setFile] = useState(  null);

  const [audioFiles, setAudioFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
    const [openSuccesPopup, setOpenSuccesPopup] = useState(false);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleRemove = () => {
    setFile(null);
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("assignment_id", selectedData?.id);
    formData.append("assignment_link", file); // ✅ correct

    setLoading(true);
    try {
      const response = await uploadAssignment(formData);

      if (response.status === 201) {
       

        const submittedData = response?.data;

        const safeSubmittedDetail = {
          id: submittedData?.id,
          status: submittedData?.status,
          submitted_date: submittedData?.submitted_date,
          assignment_link: submittedData?.assignment_link,
          assignment_object: {
            original_filename:
              submittedData?.assignment_object?.original_filename,
          },
        };

        setFilteredData((prev) =>
          prev.map((assignment) =>
            assignment.id === selectedData.id
              ? {
                  ...assignment,
                  status: "Submitted",
                  submitted_detail: safeSubmittedDetail,
                }
              : assignment,
          ),
        );

        setLoading(false);
      
        handleOpenSuccessPopup();
      } else {
        setLoading(false);
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      }
    } catch (error) {
      console.error(":", error);
      setErrorMessage("Error uploading assignment");
      handleOpenErrorPopup();
      setLoading(false);
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  
  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  return (
    <>
      <SubmitLoader open={loading} text="Uploading Assignment" />
      <Box sx={{ p: 3, fontFamily: "Inter" }}>
        <Grid container spacing={3}>
          {/* Hidden Input Field */}
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          {/* Upload Area */}
          <Grid item xs={12}>
            <Box
              onClick={() => fileInputRef.current.click()}
              sx={{
                border: "2px dashed #B38EC9",
                borderRadius: "12px",
                background: "#F9F3FF",
                textAlign: "center",
                py: 5,
                cursor: "pointer",
                transition: "0.3s",
                "&:hover": { background: "#F3E8FF" },
              }}
            >
              <CloudUploadIcon sx={{ fontSize: 42, color: "#572575" }} />

              <Typography mt={1} fontWeight={700} color="#572575">
                Drag & Drop File Here
              </Typography>

              <Typography fontSize="13px" color="#666666" mt={0.5}>
                Supported formats: MP3, WAV, M4A, AAC (Max: 50MB)
              </Typography>

              <Typography
                mt={1}
                fontSize="14px"
                fontWeight={700}
                sx={{ textDecoration: "underline", color: "#111111" }}
              >
                Upload Assignment
              </Typography>
            </Box>
          </Grid>

          {/* Audio Link */}
          {/* <Grid item xs={12}>
          <Typography fontWeight={400} mb={1} color="#572575" fontSize="16px">
            Audio Links
          </Typography>

          <TextField
            fullWidth
            placeholder="Paste Your Audio Link"
            size="small"
            sx={{ background: "#F7F7F7", borderRadius: "8px" }}
          />
        </Grid> */}

          {/* Selected Files */}
          {file && (
            <Grid item xs={12}>
              <Typography
                fontWeight={400}
                mb={1}
                color="#572575"
                fontSize="16px"
              >
                Selected File
              </Typography>

              <Stack spacing={1}>
                <Box
                  sx={{
                    background: "#9D038508",
                    borderRadius: "8px",
                    px: 2,
                    py: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <IoDocumentTextOutline
                      style={{ color: "#572575" }}
                      size={20}
                    />
                    <Typography fontSize="12px" color="#000000">
                      {file.name || file}
                    </Typography>
                  </Stack>

                  <IconButton
                    size="small"
                    onClick={handleRemove}
                    sx={{
                      background: "#CE0E00",
                      width: 18,
                      height: 18,
                      "&:hover": { background: "#FFCCCC" },
                    }}
                  >
                    <CloseIcon sx={{ color: "#EEEEEE", fontSize: 16 }} />
                  </IconButton>
                </Box>
              </Stack>
            </Grid>
          )}

          {/* Buttons */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <BlueLightOutLinedMediumButton
                buttonTitle="Cancel"
                onClick={handleClose}
              />
              <BlueSmallButton buttonTitle="Upload" onClick={handleUpload} />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle="OK"
        // startIcon={<ArticleIcon />}
        // navigateLink="/test-prep/checkout"
        // currentPathname={location.pathname}
        maxWidth="xs"
      />
         <SussceeffulyMessageScreen
              text="Assignment Uploaded Successfully"
              subText=""
              buttonTitle="Thanks, Got it"
            //   navigateLink="/test-prep/checkout"
            //   currentLink={location.pathname}
              handleClose={handleCloseSuccessPopup}
              open={openSuccesPopup}
            />
    </>
  );
}

